import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStepForwards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStepForwards"><Path fillRule="evenodd" clipRule="evenodd" d="M17 1.58594L21.4142 6.00015L17 10.4144L15.5858 9.00015L17.5858 7.00015H10.5C7.46243 7.00015 5 9.46258 5 12.5002C5 15.5377 7.46243 18.0002 10.5 18.0002H19V20.0002H10.5C6.35786 20.0002 3 16.6423 3 12.5002C3 8.35802 6.35786 5.00015 10.5 5.00015H17.5858L15.5858 3.00015L17 1.58594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStepForwards;
